import moment from 'moment';

import cloneDeep from 'lodash/cloneDeep';

class EquipmentType {
  constructor({
      id, name, description, created, modified, deleted, imported,
  }) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.created = created;
    this.modified = modified;
    this.deleted = deleted;
    this.imported = imported;
  }

  clone() {
    return cloneDeep(this);
  }

  toApiFormat() {
    return {
      ID: this.id,
      Name: this.name,
      Description: this.description,
      Created: moment(this.created),
      Modified: moment(this.modified),
      Deleted: this.deleted,
      Imported: moment(this.imported),
    };
  }

  static fromApiFormat(api) {
    return new EquipmentType({
      id: api.ID,
      name: api.Name,
      description: api.Description,
      created: api.Created,
      modified: api.Modified,
      deleted: api.Deleted,
      imported: api.Imported,
    });
  }
}

export default EquipmentType;
